const initialState = {
    responseAncillariesMasterList: [],
    responseAncillaryMaster: {},
    // responseHashExportAncillariesMaster: [],
    // responseCheckReportAncillariesMaster: [],
    // errorHashExportAncillariesMaster: false,
    // errorCheckReportAncillariesMaster: false
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };

    switch (action.type) {
        case "ANCILLARIES_MASTER_RESPONSE_LIST":
            if (action.value.detail !== undefined)
                newState.responseAncillariesMasterList = []
            else
                newState.responseAncillariesMasterList = action.value;

            newState.responseAncillaryMaster = {}
            break;

        case "GET_ANCILLARY_MASTER":
            newState.responseAncillaryMaster = {};
            break;

        case "ANCILLARY_MASTER_RESPONSE":
            newState.responseAncillaryMaster = action.value;
            break;

        case "ANCILLARY_MASTER_RESPONSE_ERROR":
            newState.responseAncillaryMaster = action.value;
            if (!newState.responseAncillaryMaster.detail) {
                newState.responseAncillaryMaster.detail = {};
            }
            break;

        // case 'HASH_EXPORT_ANCILLARIES_MASTER_RESPONSE':
        //     newState.responseHashExportAncillariesMaster = action.value;
        //     if (action.value.status !== "OK") {
        //         newState.errorHashExportAncillariesMaster = true;
        //     } else {
        //         newState.errorHashExportAncillariesMaster = false;
        //     }
        //     break;

        // case 'REPORT_EXPORT_ANCILLARIES_MASTER_RESPONSE':
        //     newState.responseCheckReportAncillariesMaster = action.value;
        //     if (action.value.status !== "OK") {
        //         newState.errorCheckReportAncillariesMaster = true;
        //     } else {
        //         newState.errorCheckReportAncillariesMaster = false;
        //     }
        //     break;

        default:
            return newState;
    }

    return newState;
};

export default reducer;
